import React from "react";
import Loadable from "../../react-loadable";

const WeaReport = Loadable({
  loader: () => import("./Report"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
export default WeaReport;



// WEBPACK FOOTER //
// ./ecology9/wea-report/index.js